import React from 'react';
import moment from 'moment';
import './ParkingItem.css';

import { FaPlus, FaMinus } from 'react-icons/fa';

const ParkingItem = (props) => {

    // 解構 props
    const { id, enterTime, lotName, plateNo, remain, categoryList, isActive, onAccordionClick } = props;

    return (
        <div className='ParkingItem'>
            <div className={`accordion ${isActive ? 'active' : ''}`}>
                {/* 手風琴標題 */}
                <div className='accordion-heading' onClick={() => onAccordionClick(id)}>
                    <div className='title-left'>{moment(enterTime).format('YYYY-MM-DD HH:mm')}</div>
                    <div className='title-right'>{remain === -1 ? '----' : `NTD.${remain}`}</div>
                    <div className='icon'>{isActive ? <FaMinus /> : <FaPlus />}</div>
                </div>

                {/* 手風琴內容 */}
                {isActive && (
                    <div className='accordion-content'>
                        <div className='info-box'>
                            <div className='lotName'>{lotName}</div>
                            <div className="plateNo">{plateNo}</div>
                            <div className="split"></div>
                            {categoryList && categoryList.map((category, catIndex) => (
                                <React.Fragment key={`${id}-category-${catIndex}`}>
                                    <div className="category-label">{category.label}</div>
                                    <div className="category-value">
                                        {category.value === -1 ? '----' : `${category.value}`}
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ParkingItem;
